<template>
    <div class="search-header">
        <div class="form">
            <div class="form-group-buttom">
                <b-form-input
                    class="iuput"
                    v-model="search"
                    type="text"
                    placeholder="Tracking Number"
                    required
                ></b-form-input>
                <img
                    class="search"
                    src="@/assets/images/icons-wr1/search.svg"
                    alt=""
                />
            </div>
        </div>
        <div class="close" @click="$emit('on-close')"></div>
    </div>
</template>

<script>
import { BNav, BFormGroup, BFormInput } from "bootstrap-vue";
export default {
    name: "Search",
    components: {
        BNav,
        BFormGroup,
        BFormInput,
    },
    data() {
        return {
            search: "",
        };
    },
};
</script>

<style lang="scss" scoped>
.search-header {
    position: absolute;
    width: initial;
    left: 0px;
    right: 0px;
    z-index: 999;
    background: #f8f7f7;

    .form {
        height: 100%;
        padding: 90px 30px;
        position: relative;
        width: 60%;
        margin: auto;

        @media (min-width: 927px) {
            width: 40%;
        }

        &-group-buttom {
            .iuput {
                position: relative;
                color: #000;

                background-color: #fff0;
                border-radius: 50px;
                border: 1px solid #2b938c;
                padding-right: 48px;
                @media (min-width: 1661px) {
                    padding: 1.5rem 3rem 1.5rem 1rem !important;
                }
                &::placeholder {
                    color: #000;
                }
            }
            .search {
                position: absolute;
                top: 50%;
                right: 45px;
                width: 33px;
                padding: 1px;
                padding-left: 10px;
                border-left: 1px solid #2b938c;
                transform: translate(0, -51%);
            }
        }
    }
    .close {
        position: absolute;
        right: 20px;
        top: 20px;
        width: 32px;
        height: 32px;
        z-index: 999;
        opacity: 0.5;

        &::before,
        &::after {
            position: absolute;
            left: 15px;
            content: " ";
            height: 33px;
            width: 2px;
            background-color: #2b938c;
        }
        &::before {
            transform: rotate(45deg);
        }
        &::after {
            transform: rotate(-45deg);
        }
    }
    .close:hover {
        opacity: 1;
    }
}
</style>
